// extracted by mini-css-extract-plugin
module.exports = {"button":"TransferValidateButton_button__M6u4k"};